import { createContext } from 'react'

export interface IReloadWrapperContext {
  reload: () => void
}

export const ReloadWrapperContext = createContext<IReloadWrapperContext>({
  reload: () => {},
})
